import styled from '../../../theme'
import { ITheme } from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const CenterText = styled.div<IWithSize>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(
    100% -
      ${(props: ITheme & IWithSize) =>
        props.size
          ? props.theme.calendar.room.width * props.size
          : props.theme.calendar.room.width}px
  );
  height: 100%;
  font-size: ${({ size }) => (size ? 1.5 * size : 1.5)}em;
  opacity: 0.4;
  position: absolute;
  top: 0;
  pointer-events: none;
  @media (max-width: ${({ theme }: ITheme) => theme.breakpoints.mobile}) {
    margin-left: 0;
    width: 100%;
    text-align: center;
    position: fixed;
    left: 0;
  }
`

const CenterTextPrint = styled.div`
  display: block;
  text-align: center;
  position: relative;
  margin-top: 150px;
  width: 100%;
`

export default CenterText
export { CenterTextPrint }
